//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { industry } from '@/utils/lecturer';
import { mapGetters } from 'vuex';

export default {
  name: 'CourseCard',
  props: {
    item: { type: Object, default: () => {} },
  },
  computed: {
    ...mapGetters('user', ['token', 'userCategory']),
    isLoginLecturer() {
      return this.token && this.userCategory === 2;
    },
  },
  methods: {
    getIndustry(item, key) {
      return industry[item][key];
    },
    onCollect(courseId) {
      this.$api('addCourseCollect', { courseId }).then(data => {
        this.$message.success('收藏成功!');
        this.item.isCollect = true;
      });
    },
    onApply(courseId) {
      this.$api('addCourseJoin', { courseId }).then(data => {
        this.$message.success('申請成功!');
        this.item.isJoin = true;
      });
    },
    onRemoveCollect(courseId) {
      this.$api('removeCourseCollect', { courseId }).then(data => {
        this.$message.success('取消收藏成功!');
        this.item.isCollect = false;
      });
    },
    onRemoveApply(courseId) {
      this.$api('removeCourseJoin', { courseId }).then(data => {
        this.$message.success('取消申請成功!');
        this.item.isJoin = false;
      });
    },
    gotoCourse(id) {
      // this.$router.push(`/Training/Course/${id}`);
    },
  },
};
